var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { get, slice, last, cloneDeep, forEach, omit } from "lodash-es";
import { Inject, Component, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { getLayoutSlot } from "../../../../lib/utils";
import { icons } from './iconIndex';
const makeEmptyRows = count => Array.from({
  length: count
}, () => ({
  type: 'w-col',
  children: [],
  props: {}
}));
const transferLayout = (oldLayout, newLayout) => {
  var _newLayout$children;
  newLayout === null || newLayout === void 0 || (_newLayout$children = newLayout.children) === null || _newLayout$children === void 0 || _newLayout$children.forEach((item, index) => {
    const oldCol = get(oldLayout, ['children', index], {});
    // col的样式 props 啥的也要弄过来
    forEach(oldCol, (value, key) => {
      if (key === 'children') return;
      if (key === 'props') {
        item[key] = omit(value, ['width', 'weight']);
        return;
      }
      item[key] = cloneDeep(value);
    });
    const oldColContent = get(oldLayout, ['children', index, 'children'], []);
    item.children = [...oldColContent];
  });
  // 多余的部分 都要塞到最后一个children里
  const restComps = slice(getLayoutSlot(oldLayout, 'default', false) || [], newLayout.children.length).map(item => item.children).flat().filter(Boolean);
  const lastColumn = last(newLayout.children);
  lastColumn === null || lastColumn === void 0 || lastColumn.children.push(...restComps);
  return newLayout;
};
const RowPresets = [{
  title: '1:1',
  layout: {
    children: makeEmptyRows(2)
  },
  icon: icons[0],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  fixLayout: layout => {}
}, {
  title: '1:2',
  layout: {
    children: makeEmptyRows(2)
  },
  icon: icons[1],
  fixLayout: layout => {
    layout.children[1].props.weight = 2;
  }
}, {
  title: '左固定:右自适应',
  layout: {
    children: makeEmptyRows(2)
  },
  icon: icons[2],
  fixLayout: layout => {
    layout.children[0].props.width = '200px';
  }
}, {
  title: '左自适应:右固定',
  layout: {
    children: makeEmptyRows(2)
  },
  icon: icons[3],
  fixLayout: layout => {
    layout.children[1].props.width = '200px';
  }
}, {
  title: '左固定:中固定:右自适应',
  layout: {
    children: makeEmptyRows(3)
  },
  icon: icons[4],
  fixLayout: layout => {
    layout.children[0].props.width = '200px';
    layout.children[1].props.width = '200px';
  }
}, {
  title: '左固定:中自适应:右固定',
  icon: icons[5],
  layout: {
    children: makeEmptyRows(3)
  },
  fixLayout: layout => {
    layout.children[0].props.width = '200px';
    layout.children[2].props.width = '200px';
  }
}];
let RowPropPanel = class RowPropPanel extends Vue {
  get activeComp() {
    return this.designer.activeComp;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "display:flex;flex-wrap:wrap;gap:8px"
    }, [RowPresets.map(item => {
      const replaceLayout = async () => {
        const newLayout = transferLayout(this.designer.activeComp, cloneDeep(item.layout));
        item.fixLayout(newLayout);
        await this.designer.modifyComp(this.designer.compPath, e => {
          this.$set(e, 'children', newLayout.children);
        });
        this.designer.activeCompInstance.$forceUpdate();
      };
      return h("div", {
        "class": "row-proppanel-preset-item"
      }, [h("img", {
        "style": "width:71px;height:40px",
        "attrs": {
          "src": item.icon
        },
        "on": {
          "click": replaceLayout
        }
      })]);
    })]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], RowPropPanel.prototype, "designer", void 0);
RowPropPanel = __decorate([Component({
  name: 'RowPropPanel',
  mixins: [vueComponentMixin]
})], RowPropPanel);
export { RowPropPanel };
//# sourceMappingURL=RowPropPanel.js.map
